import db from "@/database";

export const findAll = () => db.complementaryTherapy.toArray();
